import { createLayout, type Layout } from '@atlassian/jira-route-layout/src/index.tsx';

const rightSidebars = () => [];

export const globalLayout: Layout = createLayout({
	rightSidebars: rightSidebars(),
});
